<template>
  <div>
    <a-form :form="form" class="form-margin">
      <a-row :gutter="scene == 3 ? 0 : 24">
        <!-- 基本资料 -->
        <div class="basics">
          <div class="section4">
            <div class="mod4"></div>
            <span class="txt1">基本资料</span>
          </div>
          <a-col :span="isMobile ? 24 : 11">
            <div class="title">姓名</div>
            <a-form-item>
              <a-input :disabled="scene !== 3" v-decorator="[
                'nickname',
                {
                  rules: [
                    {
                      required: true,
                      pattern: /^.{2,30}$/,
                      message: '请输入长度为2~10位的负责人姓名',
                    },
                  ],
                  initialValue: state.nickname,
                },
              ]" placeholder="请输入您的真实姓名" @change="$forceUpdate()" />
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11">
            <div class="title">性别</div>
            <a-form-item>
              <a-select :disabled="state.gender !== 0 && scene !== 3" v-decorator="[
                'gender',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择',
                    },
                  ],
                  initialvalue: state.gender,
                },
              ]" placeholder="请选择您的性别" @change="$forceUpdate()">
                <a-select-option value="1"> 男 </a-select-option>
                <a-select-option value="2"> 女 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11">
            <div class="title">主要联络手机号</div>
            <a-form-item>
              <a-input :disabled="scene !== 3" v-decorator="[
                'mobile',
                {
                  rules: [
                    {
                      required: true,
                      pattern: /^1[3456789]\d{9}$/,
                      message: '请输入正确的手机号',
                    },
                  ],
                  initialValue: state.mobile,
                },
              ]" @change="$forceUpdate()" placeholder="请输入您常用的手机号" :maxLength="11" />
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11">
            <div class="title">身份证号</div>
            <a-form-item>
              <a-input v-decorator="[
                'cardNo',
                {
                  rules: [
                    {
                      required: requiredSetting.length && requiredSetting[10].settingValue == '1',
                      pattern:
                        /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                      message: '请输入正确的身份证号',
                    },
                  ],
                  initialValue: state.cardNo,
                },
              ]" :disabled="scene == 2" placeholder="请输入您的身份证号" @change="$forceUpdate()" />
            </a-form-item>
          </a-col>
          <a-col :span="(isMobile || (!settlementType1 && !settlementType2)) ? 24 : 11" v-if="scene == 3">
            <div class="title">结算方式</div>
            <a-form-item>
              <a-checkbox @change="changeSettlement($event, 1)" v-model="settlementType1" :disabled="scene == 2">
                结算至个人
              </a-checkbox>
              <a-checkbox @change="changeSettlement($event, 2)" v-model="settlementType2" :disabled="scene == 2">
                结算至课程方
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11" v-if="scene == 3"
            :class="{ 'hidden': settlementType1 || !settlementType2 }">
            <div class="title">结算课程方名称</div>
            <a-form-item>
              <a-input v-decorator="[
                'settlementInstitutionName',
                {
                  rules: [
                    {
                      pattern: /^.{0,45}$/,
                      message: '请输入45个字符以内的课程方名称',
                    },
                  ],

                  initialValue: state.settlementInstitutionName,
                },
              ]" :maxLength="45" :disabled="scene == 2" placeholder="请输入" @change="$forceUpdate()" />
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11" v-if="scene == 3"
            :class="{ 'hidden': settlementType2 || !settlementType1 }">
            <div class="title">银行</div>
            <a-form-item>
              <a-select :disabled="scene == 2" v-decorator="[
                'bank',
                { initialvalue: state.bank },
              ]" placeholder="请选择" allowClear @change="$forceUpdate()">
                <a-select-option :value="item.id" v-for="item in bankList" :key="item.id"> {{ item.tagName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11" v-if="scene == 3"
            :class="{ 'hidden': settlementType2 || !settlementType1 }">
            <div class="title">开户行</div>
            <a-form-item>
              <a-input v-decorator="[
                'bankName',
                {
                  rules: [
                    {
                      pattern: /^.{0,45}$/,
                      message: '请输入45个字符以内的开户行',
                    },
                  ],
                  initialValue: state.bankName,
                },
              ]" :maxLength="45" :disabled="scene == 2" placeholder="请输入开户行" @change="$forceUpdate()" />
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11" v-if="scene == 3"
            :class="{ 'hidden': settlementType2 || !settlementType1 }">
            <div class="title">银行卡号</div>
            <a-form-item>
              <a-input v-decorator="[
                'bankCardNo',
                {
                  rules: [
                    {
                      pattern: /^\d{16,19}$/,
                      message: '请输入正确的银行卡号',
                    },
                  ],

                  initialValue: state.bankCardNo,
                },
              ]" :maxLength="20" :disabled="scene == 2" placeholder="请输入您常用的银行卡号" @change="$forceUpdate()" />
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11">
            <div class="title">执教年限</div>
            <a-form-item>
              <a-select v-decorator="[
                `teachingYears`,
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择您的执教年限',
                    },
                  ],
                  initialValue: state.teachingYears,
                },
              ]" placeholder="请选择您的执教年限" :disabled="scene == 2">
                <a-select-option v-for="item in teachingYearsList" :key="item.value" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 11">
            <div class="title">Email邮件地址</div>
            <a-form-item>
              <a-input v-decorator="[
                'email',
                {
                  rules: [
                    {
                      pattern: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                      required: requiredSetting.length && requiredSetting[11].settingValue == '1',
                      message: '请输入有效的Email邮件地址',
                    },
                  ],
                  initialValue: state.email,
                },
              ]" :disabled="scene == 2" placeholder="请输入Email邮件地址" />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <div class="title">个人简介</div>
            <a-form-item>
              <a-textarea v-decorator="[
                'intro',
                {
                  rules: [{ validator: introRules }],
                  initialValue: state.intro,
                },
              ]" placeholder="请简单介绍自己，多行输入" :auto-size="{
                minRows: 5,
                maxRows: 6,
              }" :maxLength="2000" :disabled="scene == 2" />
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 8">
            <input type="file" ref="fileInput" style="display: none" accept="image/*" @change="handleFileChange" />
            <a-form-item :required="true">
              <div class="title">正面免冠照片（2寸）</div>
              <a class="protrait" @click="triggerFileInput">
                <div v-if="reqDesc.protraitPhotoUrl" @mouseenter="showMask1 = true" @mouseleave="showMask1 = false">
                  <div class="img-mask" v-show="showMask1">
                    <p>
                      <a-icon type="eye" style="margin-right: 8px;" title="预览文件" @click.stop="previewImg(1)" />
                      <a-icon type="delete" title="删除文件" @click.stop="deleteImg(1)" v-if="scene !== 2" />
                    </p>
                  </div>
                  <img :src="reqDesc.protraitPhotoUrl" alt="">
                </div>
                <a-icon v-else type="plus" style="font-size: 32px;color: #999;" />
              </a>
              <div class="errText" v-if="noProtrait">
                请上传正面免冠照片
              </div>
              <!-- <div class="remark">
                符合宽高413×626像素200KB以内，支持jpeg,jpg,png
              </div> -->
            </a-form-item>
          </a-col>

          <a-col :span="isMobile ? 24 : 8">
            <!-- --------------------------------------------------------------------- -->
            <a-form-item :required="true">
              <div class="title" ref="avatarRef">头像</div>
              <a class="avatar" @click="triggerFileInput">
                <div v-if="reqDesc.avatarUrl" @mouseenter="showMask2 = true" @mouseleave="showMask2 = false"
                  class="por">
                  <div class="img-mask h160" v-show="showMask2">
                    <p>
                      <a-icon type="eye" style="margin-right: 8px;" title="预览文件" @click.stop="previewImg(2)" />
                      <a-icon type="delete" title="删除文件" @click.stop="deleteImg(2)" v-if="scene !== 2" />
                    </p>
                  </div>
                  <img :src="reqDesc.avatarUrl" alt="">
                </div>
                <a-icon v-else type="plus" style="font-size: 32px;color: #999;" />
              </a>
              <div class="errText" v-if="noAvatar">
                请上传头像
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 8">
            <!-- --------------------------------------------------------------------- -->
            <a-form-item :required="true">
              <div class="title">
                8分钟说课视频（{{ requiredSetting.length && requiredSetting[3].settingValue == "1" ? "必" : "选" }}填）
              </div>
              <div v-if="reqDesc.talkingVideoUrl">
                <video style="height: 150px; width: 100%" controls="controls" muted="true"
                  :src="reqDesc.talkingVideoUrl"></video><a v-if="scene != 2" class="view-link"
                  @click="uploadAgain">重新上传</a>
              </div>
              <c-upload v-if="sourceFileListTalkingVideoUrl.length == 0" accept="video/*" ossType="institution"
                :disabled="scene == 2" ref="uploadVideo" :maxlength="1" :maxFileSize="419430400" :showUploadList="false"
                messageTitle="说课视频" :isSingle="false" @uploadSuccess="uploadVideo"
                :sourceFileList="sourceFileListTalkingVideoUrl" :showDownload="!isMobile"></c-upload>
              <div style="line-height: 20px" v-if="scene != 2" @click="logUrl">
                上传400MB以内mp4格式视频，如果视频不符合要求请先通过剪映等工具预先处理
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="section18"></div>
          </a-col>
        </div>
        <!-- 学历信息 -->
        <div class="information">
          <a-col :span="24">
            <div class="section4">
              <div class="mod4"></div>
              <span class="txt1">学历信息</span>
            </div>
          </a-col>
          <a-col :span="24">
            <div class="education">
              学历及毕业院校
              <span class="require">({{ requiredSetting.length && requiredSetting[0].settingValue == "0" &&
                requiredSetting[1].settingValue == "0" ? "选" : "必" }}填)</span>
            </div>
            <div class="education-rule" ref="educationRef">
              *请上传所有高中以上学历
            </div>
          </a-col>
          <div class="xueli" v-for="(item, index) in state.degreeCertificatList" :key="index">
            <a-col :span="18" v-if="index !== 0">
              <div class="outer9"></div>
            </a-col>
            <a-col :span="isMobile ? 24 : 7">
              <a-form-item>
                <a-select v-decorator="[
                  `degreeCertificatList[${index}].eduBackground`,
                  {
                    rules: [
                      {
                        required:
                          requiredSetting.length &&
                          (requiredSetting[0].settingValue == '1' ||
                            requiredSetting[1].settingValue == '1'),
                        message: '请选择您的学历',
                      },
                    ],
                    initialValue: item.eduBackground || undefined,
                  },
                ]" placeholder="请选择您的学历" :disabled="scene == 2">
                  <a-select-option v-for="(item, index) in educationSelect" :key="index" :value="item">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="isMobile ? 24 : 14" :class="{ 'df': !isMobile }">
              <a-form-item>
                <a-input v-decorator="[
                  `degreeCertificatList[${index}].text`,
                  {
                    rules: [
                      {
                        required:
                          (requiredSetting.length && (requiredSetting[0].settingValue == '1' || requiredSetting[1].settingValue == '1')) ||
                          form.getFieldValue(`degreeCertificatList[${index}].eduBackground`),
                        message: '请输入您的毕业院校',
                      },
                    ],
                    initialValue: item.text,
                  },
                ]" placeholder="请输入毕业院校" @change="$forceUpdate()" :disabled="scene == 2" />
              </a-form-item>
              <a-form-item>
                <a-input v-decorator="[
                  `degreeCertificatList[${index}].major`,
                  {
                    rules: [
                      {
                        required:
                          (requiredSetting.length && (requiredSetting[0].settingValue == '1' || requiredSetting[1].settingValue == '1')) ||
                          form.getFieldValue(`degreeCertificatList[${index}].text`),
                        message: '请输入您的专业',
                      },
                    ],
                    initialValue: item.major,
                  },
                ]" placeholder="请输入您的专业" @change="$forceUpdate()" :disabled="scene == 2" />
              </a-form-item>
            </a-col>

            <a-col :span="isMobile ? 24 : 3" v-if="index !== 0 && scene !== 2">
              <img src="/delete.png" style="width: 16px; height: 16px" alt="" />
              <a-button class="btn" type="link" @click="deleteEducation(index)" style="margin-left: -4px">
                删除</a-button>
            </a-col>
            <a-col :span="isMobile ? 12 : 7">
              <a-form-item :required="true">
                <div class="card">
                  学历证({{
                    requiredSetting.length &&
                      requiredSetting[0].settingValue == "1"
                      ? "必"
                      : "选"
                  }}填)
                </div>
                <c-upload accept="image/*" @uploadSuccess="uploadSuccess_diploma($event, index)" class="diploma"
                  :disabled="scene == 2" :isSingle="false" :maxlength="1" ref="diploma"
                  :sourceFileList="item.photoUrl2List" :showDownload="!isMobile"></c-upload>
              </a-form-item>
            </a-col>
            <a-col :span="isMobile ? 12 : 13">
              <a-form-item :required="true">
                <div class="card">
                  学位证({{
                    requiredSetting.length &&
                      requiredSetting[1].settingValue == "1"
                      ? "必"
                      : "选"
                  }}填)
                </div>
                <c-upload accept="image/*" @uploadSuccess="uploadSuccess_photoUrl($event, index)" class="diploma"
                  :disabled="scene == 2" :isSingle="false" :maxlength="1" ref="photoUrl"
                  :sourceFileList="item.photoUrlList" :showDownload="!isMobile"></c-upload>
              </a-form-item>
            </a-col>
          </div>
          <a-col :span="isMobile ? 24 : 18">
            <a-form-item>
              <a-button style="width: 365px; height: 42px" :class="[isMobile ? 'w320' : '']" type="primary" ghost
                @click="addEducationInformation"
                v-if="(!state.degreeCertificatList || state.degreeCertificatList.length < 5) && scene !== 2">
                + 新增学历信息
              </a-button>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="section18"></div>
          </a-col>
        </div>
        <!-- 其他资料 -->

        <div class="attachments">
          <a-col :span="24">
            <div class="section4">
              <div class="mod4"></div>
              <span class="txt1">其他资料</span>
            </div>
          </a-col>
          <a-col :span="isMobile ? 24 : 10">
            <a-form-item :required="true">
              <div class="card" ref="IDCardRef">身份证（正面）</div>
              <c-upload accept="image/*" :isSingle="false" :maxlength="1" class="frontIDCard"
                @uploadSuccess="uploadSuccess_frontIDCard" ref="cardFrontUrl" :disabled="scene == 2"
                :sourceFileList="sourceFileList_cardFrontUrl" :showDownload="!isMobile"></c-upload>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 10">
            <a-form-item :required="true">
              <div class="card">身份证（反面）</div>
              <c-upload accept="image/*" @uploadSuccess="uploadSuccess_backIDCard" class="backIDCard" :isSingle="false"
                :disabled="scene == 2" :maxlength="1" ref="cardBackUrl" :sourceFileList="sourceFileList_cardBackUrl"
                :showDownload="!isMobile"></c-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item>
              <div class="card" ref="healthImgRef">
                健康证明（{{ requiredSetting.length && requiredSetting[4].settingValue == "1" ? "必" : "选" }}填,至多上传5张）
              </div>
              <c-upload accept="image/*" @uploadSuccess="uploadSuccess_health" class="proveHealth" :isSingle="false"
                :disabled="scene == 2" :maxlength="5" ref="healthImgUrl" :sourceFileList="reqDesc.healthCertificateUrl"
                :showDownload="!isMobile"></c-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item>
              <div class="card">
                老师资质证书（{{ requiredSetting.length && requiredSetting[6].settingValue == "1" ? "必" : "选" }}填,至多上传5张）
              </div>
              <c-upload accept="image/*" @uploadSuccess="uploadSuccess_teacher" class="proveHealth" :isSingle="false"
                :disabled="scene == 2" :maxlength="5" ref="qualification"
                :sourceFileList="reqDesc.credentialInfoUrlList" :showDownload="!isMobile"></c-upload>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 9">
            <a-form-item>
              <div class="card" ref="noCrimeImgRef">
                无犯罪记录证明（{{ requiredSetting.length && requiredSetting[2].settingValue == "1" ? "必" : "选" }}填）
              </div>
              <c-upload accept="image/*" @uploadSuccess="uploadSuccess_criminal" class="prove" :isSingle="false"
                :disabled="scene == 2" :maxlength="1" ref="noCrimeImgUrl" :sourceFileList="sourceFileList_noCriminalUrl"
                :showDownload="!isMobile"></c-upload>
            </a-form-item>
          </a-col>
          <a-col :span="isMobile ? 24 : 7">
            <a-form-item>
              <div class="card">
                无犯罪记录证明有效期（{{ requiredSetting.length && requiredSetting[9].settingValue == "1" ? "必" : "选" }}填）
              </div>
              <a-date-picker @change="noCriminalDateChange" v-decorator="[
                'noCriminalExpiryDate',
                {
                  rules: [
                    {
                      required:
                        requiredSetting.length &&
                        requiredSetting[9].settingValue == '1',
                      message: '请选择无犯罪记录证明有效期',
                    },
                  ],
                  initialValue: this.state.noCriminalExpiryDate,
                },
              ]" :disabled="scene == 2" :inputReadOnly="true" :disabled-date="disabledDate"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item>
              <div class="card" ref="experienceRef">
                从业经验（{{ requiredSetting.length && requiredSetting[8].settingValue == "1" ? "必" : "选" }}填,至多上传5张）
              </div>
              <c-upload accept="image/*" @uploadSuccess="uploadSuccess_experience" class="proveHealth" :isSingle="false"
                :disabled="scene == 2" ref="experienceUrl" :maxlength="5" :sourceFileList="reqDesc.experience"
                :showDownload="!isMobile"></c-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item>
              <div class="card" ref="cateRef">
                授课方向（{{ requiredSetting.length && requiredSetting[7].settingValue == "1" ? "必" : "选" }}填，至多选择3项）
              </div>
              <div :class="[isMobile ? 'w-auto1' : 'w355']">
                <div class="cate" v-for="(item, index) in cateIds" :key="index">
                  <a-cascader :options="$store.state.common.courseCateLevel" :fieldNames="{
                    label: 'name',
                    value: 'id',
                    children: 'children',
                  }" :allowClear="false" @change="cateChange($event, index)" :disabled="item.disabled"
                    placeholder="请选择授课方向" :value="item.arr" style="width: 333px;"
                    :class="{ 'no-cate-border': index == cateIds.length - 1 && noCate }"
                    v-if="$store.state.common.courseCateLevel" />
                  <a-popconfirm title="确定要删除该选项吗？" @confirm="deleteOption(index)" okType="default">
                    <a style="height: 16px; transform: translateY(-13px)">
                      <a-icon type="delete" class="delete-icon" />
                    </a>
                  </a-popconfirm>
                </div>
                <div class="no-cate" v-if="noCate">请选择授课方向</div>
              </div>
              <a-button type="primary" @click="addCate()" v-if="cateIds.length < 3">
                新增授课方向
              </a-button>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item>
              <div class="card">
                授课意向时间（{{ requiredSetting.length && requiredSetting[12].settingValue == "1" ? "必" : "选" }}填，可多选）
              </div>
              <a-select mode="multiple" placeholder="请选择授课意向时间" class="w-auto2" v-decorator="[
                'teacherTeachingPlan',
                { rules: [{ required: requiredSetting.length && requiredSetting[12].settingValue == '1', message: '请选择授课意向时间' }] },
              ]">
                <a-select-option v-for="item in teachingTimeList" :key="item.value">
                  {{ item.day }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </div>
      </a-row>
      <div class="section27"></div>
      <a-form-item class="footer">
        <!-- 新建 -->
        <div v-if="scene == 1">
          <a-button class="button" :class="[isMobile ? 'mr12' : '']" :loading="saveloading" type="primary" ghost
            @click="save">
            保存
          </a-button>
          <a-button @click="submit" class="button" type="primary" :loading="loading">
            确认提交
          </a-button>
        </div>
        <!-- 查看 -->
        <div v-if="scene == 2">
          <a-button @click="submitTeacher(0)" class="button" type="primary" :loading="saveloading">
            保存
          </a-button>
        </div>
        <!-- 抽屉新建、修改 -->
        <div v-if="scene == 3" class="footer3">
          <a-button class="button" type="primary" ghost @click="close('finish', '', true)">
            取消
          </a-button>
          <a-button @click="submitTeacher(0)" class="button" type="primary" :loading="saveloading">
            保存
          </a-button>
          <a-button @click="submitTeacher(1)" class="button" type="primary" v-if="showBtn" :loading="loading">
            保存并提交审核
          </a-button>
        </div>
      </a-form-item>
    </a-form>
    <a-modal v-model="visible" @ok="submitScene1" title="确认" style="z-index: 9999;" @cancel="loading = false">
      一旦提交信息将无法修改，是否确认提交。
    </a-modal>
    <cropper :imgUrl="cropperImg" scene="avatar" :visible.sync="showCropper" @ok="handleCropped" @cancel="handleCancel">
    </cropper>
    <previewImg v-if="showPreview" @closePreview="closePreview" :img="previewUrl" :showDownload="!isMobile">
    </previewImg>
  </div>
</template>

<script>
import teacher from "../../../api/teacher";
import oss from "../../../api/oss";
import cropper from "../../../components/cropper/cropper.vue";
import CUpload from "../../../components/CUpload/CUpload.vue";
import previewImg from '../../../components/previewImg/previewImg'
import moment from "moment";
import Vue from "vue";
import dayjs from "dayjs";

const teachingTimeList = [
  { value: 1, day: "星期一" },
  { value: 2, day: "星期二" },
  { value: 3, day: "星期三" },
  { value: 4, day: "星期四" },
  { value: 5, day: "星期五" },
  { value: 6, day: "星期六" },
  { value: 7, day: "星期日" },
];
const teachingYearsList = [
  { value: 0, label: "无经验" },
  { value: 3, label: "1~3年" },
  { value: 5, label: "4~5年" },
  { value: 10, label: "6~10年" },
  { value: 11, label: "10年以上" },
];
export default {
  data() {
    return {
      originData: {},
      form: this.$form.createForm(this),
      educationSelect: ["专科", "本科", "研究生", "博士", "其他"],
      addCount: 0,
      reqDesc: {
        protraitPhotoUrl: "",
        cardFrontUrl: "",
        cardBackUrl: "",
        avatarUrl: "",
        healthCertificateUrl: [],
        noCriminalUrl: "",
        credentialInfoUrl: '',
        credentialInfoUrlList: [],
        experience: [],
        talkingVideoUrl: "",
      },
      sourceFileList: [],
      bureauId: Vue.ls.get('bureauId'),
      loading: false,
      saveloading: false,
      sourceFileList_cardBackUrl: [],
      sourceFileList_cardFrontUrl: [],
      sourceFileList_noCriminalUrl: [],
      sourceFileListTalkingVideoUrl: [],
      teachingTimeList,
      cateIds: [{ disabled: false, arr: [] }], //授课方向
      noCate: false,
      teachingYearsList,
      visible: false,
      showCropper: false,
      cropperImg: '',
      showMask1: false,
      showMask2: false,
      showPreview: false,
      noProtrait: false,
      noAvatar: false,
      previewUrl: '',
      submitData: {},
      requiredSetting: [],
      dbVideoUrl: '', // 回显视频地址
      tempVideoUrl: '', // 临时视频地址
      newVideoFlag: false,
      settlementType1: false,
      settlementType2: false,
      bankList: [],
      changeCount: 0, // 改动信息自加
    };
  },
  components: {
    CUpload,
    cropper,
    previewImg
  },
  props: {
    scene: {
      type: Number,  // 1老师修改teacherReviewChange 2老师查看teacherReview 3学校、机构老师新建修改
      required: true,
    },
    state: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
    },
    showBtn: {
      type: Boolean,
    },
    requiredSettingList: {
      type: Array,
    }
  },
  created() {
    if (this.scene == 3) {
      this.requiredSetting = this.requiredSettingList
    }
    this.bankList = Vue.ls.get('tags').filter(item => item.parentId == 1900 && item.tagGroup == 19)
  },
  mounted() {
    this.addListener()
  },

  beforeDestroy() {
    this.removeListener()
  },
  methods: {
    logUrl() {
      console.log(this.reqDesc.talkingVideoUrl)
    },
    addListener() {
      window.addEventListener('unload', this.handleUnload)
      window.addEventListener('beforeunload', this.handleBeforeUnload)
    },
    removeListener() {
      window.removeEventListener('unload', this.handleUnload)
      window.removeEventListener('beforeunload', this.handleBeforeUnload)
    },
    handleBeforeUnload(event) {
      event.preventDefault()
      event.returnValue = ''
    },
    handleUnload() {
      // 用navigator.sendBeacon发送请求，关闭窗口不支持axios，如果有视频未保存，则删除视频
      // navigator.sendBeacon(globalConfig.rootUrl + '/api/common/log', JSON.stringify({text: '关闭浏览器'}))
      if (this.tempVideoUrl) {
        const formData = new FormData()
        formData.append('url', this.tempVideoUrl)
        navigator.sendBeacon(globalConfig.rootUrl + '/api/pcWeb/aliyun/delFile', formData)
      }
    },
    //数据回显
    dataBack(data) {
      this.originData = JSON.parse(JSON.stringify(data))
      // console.log(data,'databack')
      if (data.fileUrl) {
        let a = /ware\-[0-9a-fA-F]{32}\_(.+)/gi.exec(data.fileUrl)
        let b = data.fileUrl.split('/')
        if (a[1]) {
          data.fileUrl = a[1]
        } else {
          data.fileUrl = b[b.length - 1]
        }
      }
      if (data.degreeCertificatList && data.degreeCertificatList.length) {
        data.degreeCertificatList = data.degreeCertificatList
          .map((item) => {
            if (item.teaTeacherInfoDos) {
              // 学校名 专业
              const temp1 = item.teaTeacherInfoDos.filter((item) => item.extType === 0)
              const temp2 = item.teaTeacherInfoDos.filter((item) => item.extType === 1)
              const schoolName = temp1.length && temp1[0].text ? temp1[0].text : ''
              const major = temp2.length && temp2[0].text ? temp2[0].text : ''
              // 学位
              const photoUrlList = temp2.map(i => i.fileUrl)
              const photoUrl = photoUrlList.length ? photoUrlList[0] : ''
              // 学历
              const photoUrl2List = temp1.map(i => i.fileUrl)
              const photoUrl2 = photoUrl2List.length ? photoUrl2List[0] : ''
              return {
                eduBackground: item.description,
                text: schoolName,
                major,
                photoUrl,
                photoUrlList,
                photoUrl2,
                photoUrl2List
              }
            }
          })
          .filter((item) => {
            return item.photoUrl || item.photoUrl2 || item.text
          })
      } else {
        data.degreeCertificatList = [{
          photoUrl: '',
          photoUrlList: [],
          text: '',
          major: '',
          eduBackground: '',
          photoUrl2: '',
          photoUrl2List: []
        }]
      }
      this.state.degreeCertificatList = data.degreeCertificatList

      if (data.gender == 2) {
        this.form.setFieldsValue({ gender: '女' })
      } else if (data.gender == 1) {
        this.form.setFieldsValue({ gender: '男' })
      }
      if (data.intro == 'undefined') {
        this.state.intro = ''
      } else {
        this.form.setFieldsValue({ intro: data.intro })
      }
      if (data.applyCourseType == 'undefined') {
        this.state.applyCourseType = ''
      } else {
        this.form.setFieldsValue({ applyCourseType: data.applyCourseType })
      }
      if (data.cardBackUrl) {
        this.sourceFileList_cardBackUrl.push(data.cardBackUrl) //身份证反面
        this.state.cardBackUrl = data.cardBackUrl
      }
      if (data.cardFrontUrl) {
        this.sourceFileList_cardFrontUrl.push(data.cardFrontUrl) //身份证正面
        this.state.cardFrontUrl = data.cardFrontUrl
      }
      if (data.protraitPhotoUrl) {
        this.state.protraitPhotoUrl = data.protraitPhotoUrl // 免冠照
        this.reqDesc.protraitPhotoUrl = data.protraitPhotoUrl[0].fileUrl
      }
      if (data.avatarUrl) {
        this.state.avatarUrl = data.avatarUrl // 头像
        this.reqDesc.avatarUrl = data.avatarUrl
      }
      if (data.talkingVideoUrl) {
        this.reqDesc.talkingVideoUrl = data.talkingVideoUrl[0].fileUrl
        this.dbVideoUrl = data.talkingVideoUrl[0].fileUrl
        this.sourceFileListTalkingVideoUrl.push(data.talkingVideoUrl[0].fileUrl) //8分钟说课视频
      }
      if (data.healthCertificateUrl && data.healthCertificateUrl.length !== 0) {
        this.reqDesc.healthCertificateUrl = data.healthCertificateUrl.map(
          (item) => {
            return item.fileUrl
          }
        ) //健康证明
      }
      if (data.credentialInfoUrl && data.credentialInfoUrl.length !== 0) {
        this.reqDesc.credentialInfoUrlList = data.credentialInfoUrl.map((item) => {
          return item.fileUrl
        }) //老师资质
      }
      if (data.noCriminalUrl) {
        this.sourceFileList_noCriminalUrl.push(data.noCriminalUrl[0].fileUrl) //无犯罪记录
        this.state.noCriminalUrl = data.noCriminalUrl
      }
      if (data.experience && data.experience.length !== 0) {
        this.reqDesc.experience = data.experience.map((item) => {
          return item.fileUrl
        }) //从业经验
      }
      if (data.noCrimeExpiryDate && data.noCrimeExpiryDate[0].text !== "null") {
        this.$nextTick(() => {
          this.state.noCriminalExpiryDate = moment(data.noCrimeExpiryDate[0].text);
          this.form.setFieldsValue({ noCriminalExpiryDate: this.state.noCriminalExpiryDate })
        })
      }
      // 授课方向
      if (data.categoryDOList) {
        this.cateIds = []
        data.categoryDOList.forEach(item => {
          let temp = [item.cateFirstId, item.cateSecondId || '', item.cateThirdId || '']
          temp.forEach((e, i) => {
            if (!e) temp.splice(i, 1)
          })
          this.cateIds.push({ arr: temp, disabled: true })
        })
        delete data.categoryDOList
      }
      // 意向时间
      if (data.teacherTeachingPlan) {
        let plan = data.teacherTeachingPlan.sort((a, b) => a - b)
        this.state.teacherTeachingPlan = plan
        this.form.setFieldsValue({ teacherTeachingPlan: plan })
      }
      // 结算方式相关
      if (data.settlementType) {
        data.settlementType == 1 ? this.settlementType1 = true : this.settlementType2 = true
      }
      if (data.settlementInstitutionName) {
        this.state.settlementInstitutionName = data.settlementInstitutionName
        this.form.setFieldsValue({ settlementInstitutionName: data.settlementInstitutionName })
      }
      if (data.bank) {
        this.state.bank = data.bank
        this.form.setFieldsValue({ bank: data.bank })
      }
      if (data.bankName) {
        this.state.bankName = data.bankName
        this.form.setFieldsValue({ bankName: data.bankName })
      }
      if (data.bankCardNo) {
        this.state.bankCardNo = data.bankCardNo
        this.form.setFieldsValue({ bankCardNo: data.bankCardNo })
      }
      this.$forceUpdate()
    },
    // 重新上传视频
    uploadAgain() {
      // 如果有临时传的，则删除oss中存储的旧文件
      if (this.tempVideoUrl) {
        this.deleteFile(this.tempVideoUrl)
      } else {
        // 如果没有回显视频，则删除当前的
        if (!this.dbVideoUrl) {
          this.deleteFile(this.reqDesc.talkingVideoUrl)
        }
      }
      this.newVideoFlag = true
      this.reqDesc.talkingVideoUrl = null;
      this.sourceFileListTalkingVideoUrl = []
    },
    // 个人简介规则
    introRules(rule, value, callback) {
      if (!value) {
        callback("请输入简介");
      } else if (value.trim().length === 0) {
        callback("请输入正确的简介");
      }
      callback();
    },
    disabledDate(current) {
      return current && (current > moment().add(6,'months') || current < moment().startOf('day'));
    },
    //删除学历按钮
    deleteEducation(i) {
      this.state.degreeCertificatList = this.state.degreeCertificatList.filter(
        (item, index) => i !== index
      );
      this.addCount = this.state.degreeCertificatList.length - 1;

      this.disabledSelect(this.state.degreeCertificatList);
    },
    // 无犯罪记录证明有效期改变
    noCriminalDateChange(e) {
      this.state.noCriminalExpiryDate = moment(e && e._d).format("YYYY-MM-DD");
    },
    //新增学历
    addEducationInformation() {
      this.form.validateFieldsAndScroll(
        ["degreeCertificatList"],
        (err, values) => {
          if (!err && this.requiredSetting[0].settingValue == "0" && this.requiredSetting[1].settingValue == "0") {
            let current =
              values.degreeCertificatList[
              values.degreeCertificatList.length - 1
              ];
            if (!current.eduBackground && !current.text)
              return this.$message.warning("请完善学历信息中的上一项");
            this.state.degreeCertificatList.push({
              photoUrl: "",
              photoUrlList: [],
              text: "",
              major: '',
              eduBackground: "",
              photoUrl2: "",
              photoUrl2List: [],
            });
            this.disabledSelect(values.degreeCertificatList);
            this.addCount += 1;
            return;
          } else if (!err && this.requiredSetting[0].settingValue == "1" && this.state.degreeCertificatList[this.addCount].photoUrl2) {
            this.$refs.diploma[this.addCount].check();
            if (this.requiredSetting[1].settingValue == "1") {
              this.$refs.photoUrl[this.addCount].check();
              if (!this.state.degreeCertificatList[this.addCount].photoUrl)
                return;
            }
            this.state.degreeCertificatList.push({
              photoUrl: "",
              photoUrlList: [],
              text: "",
              major: '',
              eduBackground: "",
              photoUrl2: "",
              photoUrl2List: [],
            });
            this.disabledSelect(values.degreeCertificatList);
            this.addCount += 1;
          } else if (!err && this.requiredSetting[1].settingValue == "1" && this.state.degreeCertificatList[this.addCount].photoUrl) {
            this.$refs.photoUrl[this.addCount].check();
            if (this.requiredSetting[0].settingValue == "1") {
              this.$refs.diploma[this.addCount].check();
              if (!this.state.degreeCertificatList[this.addCount].photoUrl2) return;
            }
            this.state.degreeCertificatList.push({
              photoUrl: "",
              photoUrlList: [],
              text: "",
              major: '',
              eduBackground: "",
              photoUrl2: "",
              photoUrl2List: [],
            });
            this.disabledSelect(values.degreeCertificatList);
            this.addCount += 1;
          } else {
            if (this.requiredSetting[0].settingValue == "1")
              this.$refs.diploma[this.addCount].check();
            if (this.requiredSetting[1].settingValue == "1")
              this.$refs.photoUrl[this.addCount].check();
          }
        }
      );
    },
    // 校验学历信息有图片时，背景和院校是否填写
    checkEdu() {
      if (this.form.getFieldsValue().degreeCertificatList) {
        let first = this.form.getFieldsValue().degreeCertificatList[0];
        if (
          this.state.degreeCertificatList.find(
            (item) => item.photoUrl || item.photoUrl2
          )
        ) {
          if (!first.eduBackground || !first.text) {
            this.$message.warning("请完善学历信息中的第一项");
            this.$refs.educationRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return false;
          }
        }
      }
      return true;
    },
    //学历下拉框
    disabledSelect(values) {
      let educationSelect = ["专科", "本科", "研究生", "博士", "其他"];
      this.educationSelect = educationSelect.filter(
        (item) => !values.map((item) => item.eduBackground).includes(item)
      );
    },
    //学历证
    uploadSuccess_diploma(url, index) {
      this.changeCount++
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl2 = url[0].url;
      } else {
        this.state.degreeCertificatList[index].photoUrl2 = "";
      }
    },
    //学位证
    uploadSuccess_photoUrl(url, index) {
      this.changeCount++
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl = url[0].url;
      } else {
        this.state.degreeCertificatList[index].photoUrl = "";
      }
    },
    //身份证正面
    uploadSuccess_frontIDCard(url) {
      this.changeCount++
      if (!url.length) {
        this.reqDesc.cardFrontUrl = "";
        this.state.cardFrontUrl = "";
      }
      if (url.length > 0) {
        this.reqDesc.cardFrontUrl = url[0].url;
      }
    },
    //身份证反面
    uploadSuccess_backIDCard(url) {
      this.changeCount++
      if (!url.length) {
        this.reqDesc.cardBackUrl = "";
        this.state.cardBackUrl = "";
      }
      if (url.length > 0) {
        this.reqDesc.cardBackUrl = url[0].url;
      }
    },
    //健康证明
    uploadSuccess_health(list) {
      this.changeCount++
      let arr = [];
      list.map((item) => {
        arr.push(item.url);
        return arr;
      });
      this.reqDesc.healthCertificateUrl = arr;
    },
    //无犯罪记录证明
    uploadSuccess_criminal(url) {
      this.changeCount++
      if (!url.length) {
        this.reqDesc.noCriminalUrl = "";
        this.state.noCriminalUrl[0].fileUrl = "";
      }
      if (url.length > 0) {
        this.reqDesc.noCriminalUrl = url[0].url;
      }
    },
    //老师资质
    uploadSuccess_teacher(list) {
      this.changeCount++
      let arr = [];
      list.map((item) => {
        arr.push(item.url);
        return arr;
      });
      this.reqDesc.credentialInfoUrlList = arr;
    },
    //从业经验
    uploadSuccess_experience(list) {
      this.changeCount++
      let arr = [];
      list.map((item) => {
        arr.push(item.url);
        return arr;
      });
      this.reqDesc.experience = arr;
    },
    //8分钟说课视频
    uploadVideo(list) {
      this.changeCount++
      this.reqDesc.talkingVideoUrl = list[list.length - 1].url;
      this.sourceFileListTalkingVideoUrl.push(this.reqDesc.talkingVideoUrl);
      this.tempVideoUrl = this.reqDesc.talkingVideoUrl
    },
    // 授课方向
    addCate() {
      if (
        this.cateIds.length > 0 &&
        !this.cateIds[this.cateIds.length - 1].arr.length
      ) {
        return this.$message.warn("请选择上一个授课方向");
      }
      this.cateIds.push({ disabled: false, arr: [] });
    },
    cateChange($event, index) {
      if (
        this.cateIds.some(
          (item) => JSON.stringify(item.arr) === JSON.stringify($event)
        )
      ) {
        return this.$message.warn("请勿重复选择授课方向");
      }
      this.changeCount++
      this.cateIds[index].arr = $event;
      this.noCate = false
      this.$forceUpdate();
    },
    transformCate() {
      let temp = []
      this.cateIds.forEach(item => {
        let obj = {}
        obj = {
          userId: this.state.userId,
          cateFirstId: item.arr[0],
          cateSecondId: item.arr[1],
          cateThirdId: item.arr[2] || null,
          dataType: 1
        }
        if (obj.cateThirdId == null) delete obj.cateThirdId
        temp.push(obj)
      })
      if (temp[temp.length - 1].cateFirstId) {
        this.state.categoryDOListString = JSON.stringify(temp)
      }
    },
    deleteOption(index) {
      this.changeCount++
      this.cateIds.splice(index, 1);
      if (!this.cateIds.length) {
        this.cateIds.push({ disabled: false, arr: [] })
      }
    },
    checkCate() {
      if (this.requiredSetting.length && this.requiredSetting[7].settingValue == "1") {
        if (!this.cateIds[this.cateIds.length - 1].arr.length) {
          this.noCate = true
          this.$refs.cateRef.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          return
        }
      }
    },

    // 头像 正面免冠照片
    // 选择图片
    triggerFileInput() {
      if (this.scene == 2) return
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      this.changeCount++
      const file = event.target.files[0];
      if (!file) return;
      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过2MB');
        event.target.value = ''; // 清空选择
        return;
      }
      if (file && file.type.startsWith('image/')) {
        this.processImageFile(file);
      }
      event.target.value = '';
    },
    processImageFile(file) {
      this.fileToDataURL(file).then(res => {
        this.cropperImg = res
        this.showCropper = true
      })
    },
    // file文件转base64
    fileToDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    handleCropped(url1, url2) {
      this.showCropper = false
      this.reqDesc.avatarUrl = url1 ? url1 : ''
      this.reqDesc.protraitPhotoUrl = url2 ? url2 : ''
      this.noAvatar = false
      this.noProtrait = false
      this.showMask1 = false
      this.showMask2 = false
    },
    handleCancel() {
      this.showCropper = false
    },
    previewImg(type) {
      if (type == 1) {
        this.previewUrl = this.reqDesc.protraitPhotoUrl
      } else {
        this.previewUrl = this.reqDesc.avatarUrl
      }
      this.showPreview = true
    },
    deleteImg(type) {
      if (type == 1) {
        this.reqDesc.protraitPhotoUrl = ''
      } else {
        this.reqDesc.avatarUrl = ''
      }
    },
    closePreview() {
      this.showPreview = false
    },
    protraitPhotoUrlCheck() {
      let flag = this.reqDesc.protraitPhotoUrl ? true : false
      this.noProtrait = !flag
      return flag
    },
    avatarUrlCheck() {
      let flag = this.reqDesc.avatarUrl ? true : false
      this.noAvatar = !flag
      return flag
    },
    changeSettlement(e, type) {
      if (e.target.checked) {
        if (type == 1) {
          this.settlementType2 = false
        } else {
          if (this.$ls.get('roleId') == 4 && !this.form.getFieldValue('settlementInstitutionName')) {
            this.form.setFields({
              settlementInstitutionName: {
                value: this.$ls.get('institutionName'),
              },
            });
          }
          this.settlementType1 = false
        }
      }
    },
    //校验
    checkoutPerson(err) {
      this.checkCate()
      if (this.noCate) return
      return new Promise((resolve) => {
        let qualificationFlag;
        let degreeFlag;
        this.state.degreeCertificatList.forEach((item, index) => {
          if (this.requiredSetting[0].settingValue == "0")
            return (qualificationFlag = true);
          this.$refs.diploma[index].check();
          return (qualificationFlag = !item.photoUrl2 ? false : true);
        });
        this.state.degreeCertificatList.forEach((item, index) => {
          if (this.requiredSetting[1].settingValue == "0")
            return (degreeFlag = true);
          this.$refs.photoUrl[index].check();
          return (degreeFlag = !item.photoUrl ? false : true);
        });
        Promise.all([
          this.requiredSetting[5].settingValue == "1"
            ? this.protraitPhotoUrlCheck()
            : true, // 免冠照
          this.requiredSetting[5].settingValue == "1"
            ? this.avatarUrlCheck()
            : true, // 头像
          qualificationFlag, // 学历
          degreeFlag, // 学位
          this.requiredSetting[10].settingValue == "1"
            ? this.$refs.cardFrontUrl.check()
            : true, // 身份证正面
          this.requiredSetting[10].settingValue == "1"
            ? this.$refs.cardBackUrl.check()
            : true, // 身份证反面
          this.requiredSetting[4].settingValue == "1"
            ? this.$refs.healthImgUrl.check()
            : true, // 健康证明
          this.requiredSetting[6].settingValue == "1"
            ? this.$refs.qualification.check()
            : true, // 师资
          this.requiredSetting[2].settingValue == "1"
            ? this.$refs.noCrimeImgUrl.check()
            : true, // 无犯罪记录证明
          this.requiredSetting[8].settingValue == "1"
            ? this.$refs.experienceUrl.check()
            : true, // 从业经验
        ]).then((res) => {
          let res1 = res.every((item) => item === true);
          resolve(res1);
          if (err) return;
          if (!res[0] || !res[1]) {
            this.$refs.avatarRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return;
          }
          if (!res[2] || !res[3]) {
            this.$refs.educationRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return;
          }
          if (!res[4] || !res[5]) {
            this.$refs.IDCardRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
          if (!res[6]) {
            this.$refs.healthImgRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return;
          }
          if (!res[8]) {
            this.$refs.noCrimeImgRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return;
          }
          if (!res[9]) {
            this.$refs.experienceRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return;
          }
        });
      });
    },
    // scene1 下的保存、提交
    save() {
      if (!this.checkEdu()) return;
      this.saveloading = true;
      let value = this.form.getFieldsValue();
      this.handleSubmit(value, 0)
    },
    submit() {
      if (!this.checkEdu()) return;
      this.form.validateFieldsAndScroll((err, values) => {
        this.checkoutPerson(err).then(async (res) => {
          if (!err && res === true) {
            this.loading = true
            this.handleSubmit(values, 1)
          }
        });
      });
    },
    //提交
    submitTeacher(type) {
      if (!this.checkEdu()) return
      // scene为2时不需要校验表单内容以及必填项
      if (this.scene == 2) {
        const values = this.form.getFieldsValue()
        this.saveloading = true
        this.handleSubmit(values, type)
        return
      }
      // 教育局需要审核，仅保存时
      if (this.showBtn && type == 0) {
        this.form.validateFieldsAndScroll(['mobile', 'gender', 'nickname'], (err, values) => {
          if (!err) {
            const values2 = this.form.getFieldsValue()
            this.saveloading = true
            this.handleSubmit(values2, type)
          }
        })
        return
      }
      this.form.validateFieldsAndScroll((err, values) => {
        this.checkoutPerson(err).then(async (res) => {
          if (!err && res === true) {
            this.loading = true
            // 如果有上传新的视频，删除旧视频
            if (this.newVideoFlag) {
              this.deleteFile(this.dbVideoUrl)
            }
            this.handleSubmit(values, type)
          }
        })
      })
    },
    handleSubmit(values, type) {
      let arr = []
      this.state.degreeCertificatList.map((item, index) => {
        if (values.degreeCertificatList && values.degreeCertificatList.length) {
          values.degreeCertificatList.map((i, v) => {
            if (index === v) {
              arr.push({ ...item, ...i })
              return arr
            }
          })
        }
      })
      arr.forEach((item, index) => {
        for (let k in item) {
          if (!item[k] || !item[k].length) {
            delete item[k]
          }
        }
        if (!item.eduBackground || !item.text) {
          arr.splice(index, 1)
        }
      })
      let credentialInfoUrlDemo = []
      if (this.reqDesc.credentialInfoUrlList.length !== 0) {
        credentialInfoUrlDemo = this.reqDesc.credentialInfoUrlList
      }
      let experienceDemo = []
      if (this.reqDesc.experience.length !== 0) {
        experienceDemo = this.reqDesc.experience
      }
      if (this.cateIds.length) {
        this.transformCate()
      }
      const data = {
        ...this.state,
        ...values,
        degreeCertificatListString: arr.length ? JSON.stringify(arr) : null,
        ...this.reqDesc,
        bureauId: this.bureauId,
        gender: (values.gender == '1' || values.gender == '2') ? values.gender : values.gender == '男' ? 1 : 2,
        cardFrontUrl:
          this.reqDesc.cardFrontUrl || this.state.cardFrontUrl,
        cardBackUrl: this.reqDesc.cardBackUrl || this.state.cardBackUrl,
        protraitPhotoUrl:
          this.reqDesc.protraitPhotoUrl ||
          (this.state.protraitPhotoUrl &&
            this.state.protraitPhotoUrl[0].fileUrl),
        avatarUrl: this.reqDesc.avatarUrl || this.state.avatarUrl,
        noCriminalUrl:
          this.reqDesc.noCriminalUrl ||
          (this.state.noCriminalUrl &&
            this.state.noCriminalUrl[0].fileUrl),
        credentialUrl: credentialInfoUrlDemo.join(';'),
        experience: experienceDemo
      }
      if (data.noCriminalExpiryDate) {
        data.noCriminalExpiryDate = moment(this.state.noCriminalExpiryDate).format('YYYY-MM-DD')
      }
      delete data.noCrimeExpiryDate
      delete data.degreeCertificatList
      delete data.credentialInfoUrlList
      if (data.settlementTypeString) delete data.settlementTypeString
      for (let key in data) {
        if (data[key] == undefined) {
          data[key] = ''
        }
      }
      data.settlementType = this.settlementType1 ? 1 : this.settlementType2 ? 2 : 0
      // console.log(data, '提交数据')
      if (this.scene == 1) {
        if (type == 1) {
          this.submitData = data
          this.visible = true
        } else {
          // 如果上传了新视频，删除回显的旧视频
          if (this.newVideoFlag && this.dbVideoUrl) {
            this.deleteFile(this.dbVideoUrl)
          }
          this.updateTeacherSelf(data)
        }
      } else if (this.scene == 2) {
        this.updateTeacherSelf(data)
      } else {
        if (this.userId) {
          this.updateTeacher(data, type)
        } else {
          this.addTeacher(data, type)
        }
      }
    },
    // 场景1提交与保存
    submitScene1() {
      teacher.updateSelf({ ...this.submitData, type: "submit" }).then((res) => {
        // 如果上传了新视频，删除回显的旧视频
        if (this.newVideoFlag && this.dbVideoUrl) {
          this.deleteFile(this.dbVideoUrl)
        }
        if (res.data.status === 0 || res.data.status === 1) {
          this.status = 0;
          this.$store.commit(
            "register/changeStatus",
            this.status
          );
          this.$router.replace("/teacherReview");
        }
      }).finally((e) => {
        this.visible = false
        this.loading = false
      })
    },
    // 场景1、2修改老师
    updateTeacherSelf(data) {
      teacher.updateSelf({ ...data, type: "save" }).then((res) => {
        this.$message.success("保存成功");
        if (this.cateIds) {
          this.cateIds.forEach((item, index) => {
            let last = this.cateIds.length - 1;
            if (index == last) {
              if (item.arr.length) {
                item.disabled = true
              } else {
                item.disabled = false
                if (last > 0) {
                  this.cateIds.splice(last, 1)
                }
              }
            } else {
              item.disabled = true
            }
          })
        }
        let teacherPlan = this.form.getFieldsValue().teacherTeachingPlan
        if (teacherPlan) {
          let plan = teacherPlan.sort((a, b) => a - b)
          this.state.teacherTeachingPlan = plan
          this.form.setFieldsValue({ teacherTeachingPlan: plan })
        }
        // 更新保存后的回显视频，用于再次上传新视频后更新的删除
        if (res.data.talkingVideoUrl) {
          this.dbVideoUrl = res.data.talkingVideoUrl[0].fileUrl
          this.tempVideoUrl = ''
          this.newVideoFlag = false
        } else {
          // 删除了视频没有传新的
          if (this.dbVideoUrl) {
            this.deleteFile(this.dbVideoUrl)
            this.dbVideoUrl = ''
          }
        }
      }).finally((err) => {
        this.saveloading = false;
      });
    },
    // 场景3新增老师
    addTeacher(data, type) {
      const newParams = data
      newParams.cardBackUrl = this.reqDesc.cardBackUrl
      newParams.cardFrontUrl = this.reqDesc.cardFrontUrl
      if (type) {
        newParams.saveType = 1
      } else {
        newParams.saveType = this.showBtn ? 0 : 1
      }
      teacher.addTeacher(newParams).then((res) => {
        this.$message.success('新增成功')
        this.close('finish', true)
      }).finally(() => {
        this.saveloading = false
        this.loading = false
      })
    },
    // 场景3修改老师
    updateTeacher(data, type) {
      const newParams = data
      let userId = this.scene == 2 ? data.userId : this.userId
      if (this.scene == 2) {
        newParams.saveType = 0
      } else {
        if (type) {
          newParams.saveType = 1
        } else {
          newParams.saveType = this.showBtn ? 0 : 1
        }
      }
      teacher.updateTeacher(userId, newParams).then((res) => {
        this.$message.success('修改成功')
        this.close('finish', true)
      }).finally(() => {
        this.saveloading = false
        this.loading = false
      })
    },
    // 场景3关闭抽屉校验
    close(flag, noDel, cancel = false) {
      if (this.haveChanged() && flag !== 'finish') {
        let _this = this
        this.$confirm({
          title: "提示",
          content: "您编辑的信息暂未保存，是否继续退出？",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            _this.$emit('handleClose');
            // 如果没视频，上传了后取消了，则删除上传的视频
            if (!_this.dbVideoUrl && _this.reqDesc.talkingVideoUrl) {
              _this.deleteFile(_this.reqDesc.talkingVideoUrl)
            }
            // 如果有视频并点击了重新上传，取消则删除后上传视频
            if (this.newVideoFlag && this.dbVideoUrl && this.reqDesc.talkingVideoUrl) {
              this.deleteFile(this.reqDesc.talkingVideoUrl)
            }
            this.clearData();
          },
          onCancel: () => {
            return;
          },
        });
      } else {
        // 下方按钮取消不弹出提示
        this.$emit('handleClose', flag);
        // 如果有新上传的视频，则删除
        if (!this.dbVideoUrl && this.reqDesc.talkingVideoUrl && !noDel) {
          this.deleteFile(this.reqDesc.talkingVideoUrl)
        }
        // 如果有视频并点击了重新上传，保存则删除回显的视频，取消则删除后上传视频
        if (this.newVideoFlag && this.dbVideoUrl && this.reqDesc.talkingVideoUrl) {
          this.deleteFile(cancel ? this.reqDesc.talkingVideoUrl : this.dbVideoUrl)
        }
        this.clearData();
      }
    },
    haveChanged() {
      if (this.changeCount) return true
      let formData = this.form.getFieldsValue()
      // 如果上传过视频
      if (this.reqDesc.talkingVideoUrl != this.dbVideoUrl) return true
      for (let k in formData) {
        if (k == 'teachingYears') {
          if (formData[k] == 0 && this.originData.teachingYears) {
            return true
          }
        }
        if (k == 'degreeCertificatList') {
          let changed = false
          formData[k].forEach(item => {
              let temp = this.originData.degreeCertificatList? this.originData.degreeCertificatList.find(item2 => item2.description == item.eduBackground) : null
              if (!temp) {
                for (let k2 in item) {
                  if (item[k2]) {
                    return changed = true
                  }
                }
              } else {
                for (let k2 in item) {
                  if (k2 == 'text') {
                    if (item[k2] != temp.teaTeacherInfoDos[1].text) {
                      changed = true
                    }
                  }
                  if (k2 == 'major') {
                    if (item[k2] != temp.teaTeacherInfoDos[0].text) {
                      changed = true
                    }
                  }
                }
              }
          })
          if (changed) {
            return true
          }
        } else if (k == 'gender') {
          if (formData[k] != this.originData.genderText) {
            return true
          }
        } else if (k == 'noCriminalExpiryDate') {
          if (this.originData.noCrimeExpiryDate && (dayjs(formData[k]).format('YYYY-MM-DD') != this.originData.noCrimeExpiryDate[0].text)) {
            return true
          }
        } else if (k == 'teacherTeachingPlan') {
          if (JSON.stringify(formData[k]) != JSON.stringify(this.originData[k])) {
            return true
          }
        } else if (k == 'intro') {
          console.log(formData[k],this.originData.intro,'intro')
          if(!this.originData.intro){
            if (formData[k]) {
              return true
            }
          } else {
            if (formData[k] != this.originData.intro) {
              return true 
            }
          }
          
        } else {
          if (formData[k] != this.originData[k]) {
            console.log('不一致', k, formData[k], this.originData[k],this.originData)
            return true
          }
        }
      }
      return false
    },
    deleteFile(url) {
      let params = { url: url }
      oss.delFile(params).then(() => {
      })
      this.tempVideoUrl = ''
      this.newVideoFlag = false
    },
    clearData() {
      this.changeCount = 0
      this.originData = {}
      this.form.resetFields()
      this.reqDesc = {
        protraitPhotoUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        avatarUrl: '',
        healthCertificateUrl: [],
        noCriminalUrl: '',
        credentialInfoUrlList: [],
        experience: [],
        talkingVideoUrl: '',
      }
      this.settlementType1 = false
      this.settlementType2 = false
      this.dbVideoUrl = ''
      this.tempVideoUrl = ''
      this.newVideoFlag = false
      this.sourceFileList_cardBackUrl = []
      this.sourceFileList_cardFrontUrl = []
      this.sourceFileList_noCriminalUrl = []
      this.sourceFileListTalkingVideoUrl = []
      this.cateIds = [{ disabled: false, arr: [] }]
      this.removeListener()
    }
  },
};
</script>

<style lang="scss" scoped>
.section4 {
  z-index: auto;
  height: 22px;
  margin-bottom: 39px;
}

.mod4 {
  z-index: 79;
  width: 9px;
  height: 20px;
  border-radius: 4.5px 4.5px 4.5px 4.5px;
  background-color: rgba(78, 148, 255, 1);
  margin-top: 1px;
  display: inline-block;
}

.txt1 {
  z-index: 65;
  height: 22px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(78, 148, 255, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  line-height: 22px;
  text-align: left;
  vertical-align: top;
  margin-left: 12px;
}

.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.education {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.education-rule {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff7032;
  margin-bottom: 20px;
}

.section18 {
  z-index: 38;
  width: 100%;
  height: 4px;
  background-color: rgba(248, 248, 248, 1);
  align-self: center;
  margin: 10px 0;
}

.card {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.section27 {
  z-index: 35;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 40px;
}

.button {
  width: 140px;
  height: 42px;
  margin-left: 24px;
}

.footer {
  text-align: center;
  margin-top: 23px;
}

.remark {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #87888a;
  line-height: 20px;
}

.errText {
  color: red;
  font-size: 14px;
  line-height: 14px;
  margin-top: 5px;
}

.protrait {
  width: 160px;
  height: 242px;
  border: 0;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 2;
  }
}

.avatar {
  width: 160px;
  height: 160px;
  border: 0;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .por {
    position: relative;
    width: 160px;
    height: 160px;

    .img-mask {
      position: absolute;
    }
  }
}

.img-mask {
  position: absolute;
  width: 160px !important;
  height: 242px !important;
  width: 100%;
  height: 100%;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: 16px;
}

.h160 {
  height: 160px !important;
}

//背景图
::v-deep .backgroundImage .ant-upload {
  width: 750px;
  height: 250px;
  border: 0;

  .ant-upload-text {
    display: none;
  }

  .ant-spin {
    width: 50%;
    height: 94%;
  }
}

::v-deep .backgroundImage .ant-spin-nested-loading {
  width: 750px;
}

::v-deep .backgroundImage .ant-upload-list-picture-card-container {
  width: 750px;
  height: 250px;
  border: 0;
}

::v-deep .backgroundImage .ant-upload-list-item {
  width: 750px;
  height: 250px;
  border: 0;
}

::v-deep .schoolPermit .ant-upload {
  width: 297px;
  height: 210px;
  border: 0;

  .ant-upload-text {
    display: none;
  }

  .ant-spin {
    width: 50%;
    height: 94%;
  }
}

::v-deep .schoolPermit .ant-spin-nested-loading {
  width: 297px;
}

//头像
::v-deep .headPortrait .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

::v-deep .headPortrait .ant-spin-nested-loading {
  width: 160px;
}

//LOGO
::v-deep .LOGO .ant-upload {
  width: 250px;
  height: 250px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

::v-deep .LOGO .ant-spin-nested-loading {
  width: 250px;
}

::v-deep .LOGO .ant-upload-list-picture-card-container {
  width: 250px;
  height: 250px;
  border: 0;
}

::v-deep .LOGO .ant-upload-list-item {
  width: 250px;
  height: 250px;
  border: 0;
}

::v-deep .diploma .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

::v-deep .diploma .ant-spin-nested-loading {
  width: 160px;
}

::v-deep .frontIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  background: url(/home/frontIDCard.png) no-repeat center;
  background-size: 100% 100%;

  .ant-upload-text {
    display: none;
  }

  .anticon-plus {
    display: none;
  }

  .ant-spin-nested-loading>div>.ant-spin .ant-spin-dot {
    left: 33%;
  }
}

::v-deep .backIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  margin-left: 0px;
  background: url(/home/backIDCard.png) no-repeat center;
  background-size: 100% 100%;

  .ant-upload-text {
    display: none;
  }

  .anticon-plus {
    display: none;
  }
}

::v-deep .prove .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

::v-deep .prove .ant-spin-nested-loading {
  width: 160px;
}

::v-deep .otherMaterialsUrls .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}

::v-deep .proveHealth .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  ::v-deep .ant-upload-list-item-list-type-picture-card {
    width: 160px;
    height: 160px;
    border: 0;
  }

  ::v-deep .ant-upload-list-item {
    width: 160px;
    height: 160px;
    border: 0;
  }

  .ant-upload-text {
    display: none;
  }
}

::v-deep .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}

::v-deep .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}


::v-deep .schoolPermit .ant-upload-list-picture-card-container {
  width: 297px;
  height: 210px;
  border: 0;
}

::v-deep .schoolPermit .ant-upload-list-item {
  width: 297px;
  height: 210px;
  border: 0;
}

::v-deep .otherMaterialsUrls .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}

::v-deep .otherMaterialsUrls .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}

::v-deep .otherMaterialsUrls .ant-upload-picture-card-wrapper {
  width: 100%;
}

::v-deep .frontIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}

::v-deep .frontIDCard .ant-spin-nested-loading {
  width: 320px;
}

::v-deep .frontIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

::v-deep .backIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}

::v-deep .backIDCard .ant-spin-nested-loading {
  width: 320px;
}

::v-deep .backIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

::v-deep .btn {
  width: 36px;
  height: 25px;
  font-size: 17px;
  margin-top: 10px;
  vertical-align: bottom;
}

.outer9 {
  z-index: 37;
  width: 130%;
  height: 1px;
  // background-color: #000;
  background-color: #f8f8f8;
  margin-top: 20px;
  margin-bottom: 20px;
}

.view-link {
  display: block;
  text-align: center;
}

.require {
  padding-left: 5px;
  color: red;
  font-size: 14px;
  font-weight: 400;
}

.w320 {
  width: 320px !important;
}

@media screen and (max-width: 800px) {

  ::v-deep .ant-card-body {
    padding: 12px !important;
  }

  ::v-deep .ant-col {
    padding: 0 !important;
  }

  .form-margin {
    margin: 40px 0 0 9px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .footer {
    width: 100%;

    .df {
      display: flex;
      justify-content: space-evenly;
    }

    .button {
      margin-left: 0;
    }

    .mr12 {
      margin-right: 12px;
    }
  }
}

.df {
  display: flex;
}

.w200 {
  width: 200px;
}

.mr10 {
  margin-right: 10px;
}

.cate {
  margin-bottom: 6px;
  display: flex;
  align-items: center;

  ::v-deep .ant-cascader-input {
    width: 333px;
  }

  a {
    color: #c0c4cc;
    margin-left: 8px;
  }
}

.w600 {
  width: 600px;
}

.w355 {
  max-width: 355px;
}

.w-auto1 {
  zoom: 0.9;
}

.w-auto2 {
  max-width: 600px;
  width: calc(100vw - 68px);
}

.no-cate {
  color: #f5222d;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  margin-top: -5px;
}

.no-cate-border {
  ::v-deep .ant-cascader-input {
    border: 1px solid #f5222d !important;

  }
}

.footer3 {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  background-color: #fff;
  border-top: 1px solid #f8f8f8;
  width: calc(70vw - 36px);
  z-index: 100;
  padding: 23px 0;
}

.hidden {
  display: none;
}
</style>